import React from 'react'

import ClickableAsset from '../../components/ClickableAsset/ClickableAsset.index'

export interface SubscribeNowBannerButtonProps {
  alt: string;
  colorSchema: 'secondary' | 'tertiary';
  href: string;
  imgSrc: string;
  imgHeight: string;
  imgWidth: string;
  isUnstyled?: boolean;
}

const SubscribeNowBannerButton: React.FC<SubscribeNowBannerButtonProps> = ({ alt, colorSchema, href, imgSrc, imgHeight, imgWidth, isUnstyled }) => {

  const color = colorSchema === 'secondary' ? '$secondaryMain' : '$tertiaryMain'

  const styles = {
    align: ['row', 'center', 'middle'],
    backgroundColor: color,
    borderColor: color,
    borderRadius: '2px',
    height: '40px',
    px: '$2'
  }

  return (
    <ClickableAsset
      alt={alt}
      src={imgSrc}
      href={href}
      height={imgHeight}
      id='assine-agora-menu'
      width={imgWidth}
      css={{ container: isUnstyled ? {} : styles }}
    />
  )
}

export default SubscribeNowBannerButton